import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ScientificAreaType } from "../../../types/ScientificAreas";

const initialState: ScientificAreaType = {
    id: "",
    description: "",
};
export const scientificAreaSlice = createSlice({
    name: "scientificAreaForm",
    initialState,
    reducers: {
        setUpdateScientificAreaData: (
            state, action: PayloadAction<ScientificAreaType>,
        ) => {
            return { ...state, ...action.payload };
        },
        resetUpdateScientificAreaData: (
            state,
        ) => {
            return initialState
        }
    }
});
export const { setUpdateScientificAreaData,resetUpdateScientificAreaData } = scientificAreaSlice.actions;
export default scientificAreaSlice.reducer;